import React from "react";
import { getCategories } from '@lds/store-locator-js-sdk';
export const useStoreCategories = (options) => {
    const [categories, setCategories] = React.useState();
    const [error, setError] = React.useState();
    const [isLoading, setIsLoading] = React.useState(false);
    // eslint-disable-next-line consistent-return
    const getAllCategories = React.useCallback(async () => {
        setIsLoading(true);
        try {
            if (!options || !options.clientId) {
                setCategories(undefined);
                setError(undefined);
                setIsLoading(false);
            }
            else {
                const { catList, error: er } = await getCategories(options);
                setCategories(catList);
                setError(er);
                setIsLoading(false);
                return catList;
            }
        }
        catch (errx) {
            setError(errx);
            setCategories(undefined);
            setIsLoading(false);
        }
    }, [options]);
    return { categories, error, isLoading, getAllCategories };
};
//# sourceMappingURL=useStoreCategories.js.map